import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useState } from "react";
import { FaqItem } from "../../../api/faqApi";
import { useFaqItems } from "../../../hooks/react-query/faq/useFaqItems";

const FaqQuestionItem = (props: { item: FaqItem }) => {
  const { item } = props;
  const [open, setOpen] = useState(false);

  return (
    <div className="faq_question_item" data-test-id={`faq-question-${item.id}`}>
      <button className="faq_question_header" onClick={() => setOpen(!open)} aria-expanded={open}>
        <span>{item.question}</span>
        {open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      </button>
      {open && (
        <div className="faq_question_answer">
          {/* white-space: pre-line (faqPage.scss) preserves literal newlines in the backend's
              plain-string answer, rather than assuming markdown/HTML formatting support. */}
          <p>{item.answer}</p>
          {item.external_link && (
            <a className="faq_question_link" href={item.external_link} target="_blank" rel="noopener noreferrer">
              Learn more
            </a>
          )}
        </div>
      )}
    </div>
  );
};

export const FaqAccordion = () => {
  const { items } = useFaqItems();

  return (
    <div className="faq_accordion">
      {items.map((item) => (
        <FaqQuestionItem item={item} key={item.id} />
      ))}
    </div>
  );
};
